export default class Modal {
  /**
   * @param {HTMLDialogElement} element
   */
  constructor(element) {
    this.element = element;
    this.elements = {
      trigger: document.querySelectorAll(`[data-modal="${this.element.id}"]`),
    };
    this.trigger = null;

    this.elements.trigger.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        this.element.showModal();
        this.trigger = button;
      });
    });

    if (this.element.open) {
      this.element.open = false;
      this.element.showModal();
    }

    this.element.addEventListener("close", () => {
      if (this.trigger) {
        this.trigger.focus();
      }
    });
  }
}
